import { drawWithImagePatternWrapper } from 'src/util/canvasImagePattern'

export const middleFingerCover = async (
  ctx: CanvasRenderingContext2D,
  leatherColor: string,
  stitchColor: string,
  x: number,
  y: number,
  numerator: number,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.save()
  ctx.rotate((numerator * Math.PI) / 180)
  const drawCover = () => {
    ctx.lineWidth = 1.0
    ctx.beginPath()
    ctx.moveTo(372 + x, 345 + y)
    ctx.quadraticCurveTo(385 + x, 278 + y, 398 + x, 240 + y)
    ctx.quadraticCurveTo(405 + x, 210 + y, 435 + x, 205 + y)
    ctx.quadraticCurveTo(458 + x, 213 + y, 455 + x, 241 + y)
    ctx.quadraticCurveTo(436 + x, 361 + y, 436 + x, 351 + y)
    ctx.quadraticCurveTo(432 + x, 353 + y, 413 + x, 377 + y)
    ctx.quadraticCurveTo(375 + x, 403 + y, 362 + x, 380 + y)
    ctx.quadraticCurveTo(363 + x, 365 + y, 372 + x, 345 + y)
    ctx.fill()
    ctx.strokeStyle = '#3b3b3b'
    ctx.stroke()
    ctx.closePath()
  }
  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawCover, leatherColor)
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(381 + x, 330 + y)
  ctx.quadraticCurveTo(385 + x, 290 + y, 404 + x, 235 + y)
  ctx.quadraticCurveTo(412 + x, 212 + y, 435 + x, 211 + y)
  ctx.quadraticCurveTo(445 + x, 212 + y, 451 + x, 229 + y)
  ctx.quadraticCurveTo(432 + x, 356 + y, 432 + x, 347 + y)
  ctx.moveTo(385 + x, 310 + y)
  ctx.quadraticCurveTo(387 + x, 290 + y, 408 + x, 235 + y)
  ctx.quadraticCurveTo(414 + x, 214 + y, 435 + x, 215 + y)
  ctx.quadraticCurveTo(443 + x, 214 + y, 447 + x, 231 + y)
  ctx.quadraticCurveTo(430 + x, 354 + y, 428 + x, 348 + y)
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = '#3b3b3b'
  ctx.closePath()
  ctx.restore()
}
